import AppState from '../app-state';
import type { PanelSizingState, ReduxAction } from '@repo/utils/types';

export const selectNavBarWidth = (state: AppState) => {
  return state.ui.panelSizing.navBarWidth;
};

export const selectRightSidebarWidth = (state: AppState) => {
  return state.ui.panelSizing.rightSidebarWidth;
};

const initialPanelSizingState = {
  navBarWidth: 200,
  rightSidebarWidth: 360,
};

export function panelSizingReducer(
  state: PanelSizingState = initialPanelSizingState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'LOAD_LOCAL_STORE_SUCCEEDED':
      return {
        ...state,
        navBarWidth: payload.get('nav_bar_width') || initialPanelSizingState.navBarWidth,
        rightSidebarWidth:
          payload.get('right_sidebar_width') || initialPanelSizingState.rightSidebarWidth,
      };

    case 'RESIZE_NAV_BAR':
      return {
        ...state,
        navBarWidth: payload.width,
      };

    case 'RESIZE_RIGHT_SIDEBAR':
      return {
        ...state,
        rightSidebarWidth: payload.width,
      };

    default:
      return state;
  }
}
